import React from 'react';
import { useAdminInfo } from '../AdminInfoProvider';
import AddressCard from './AddressCard';

function AddressCont({ addressData }) {
    const { addressShow, adminInfoData } = useAdminInfo();
    return (
        <div
            className={`flex gap-10 justify-around mb-5 transition-all duration-[600ms] ease-in-out overflow-hidden ${
                !addressShow ? 'max-h-0' : 'max-h-[260px]'
            }`}
        >
            <AddressCard
                disabled={adminInfoData?.status !== 'active'}
                title="administrative"
                addressData={addressData?.administrative}
            />
            <AddressCard
                disabled={adminInfoData?.status !== 'active'}
                title="billing"
                addressData={addressData?.billing}
            />
            <AddressCard
                disabled={adminInfoData?.status !== 'active'}
                title="technical"
                addressData={addressData?.technical}
            />
        </div>
    );
}

export default AddressCont;
